import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { BsArrowRight } from 'react-icons/bs';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Facilities.css';

// Import Images
import img1 from "../../assets/Manufacture/img1 (1).png";
import img2 from "../../assets/Manufacture/img1 (2).png";
import img3 from "../../assets/Manufacture/img1 (3).png";
import img4 from "../../assets/Manufacture/img2 (1).png";
import img5 from "../../assets/Manufacture/img2 (2).png";
import img6 from "../../assets/Manufacture/img2 (3).png";
import img7 from "../../assets/Manufacture/img3 (1).png";
import img8 from "../../assets/Manufacture/img3 (2).png";
import img9 from "../../assets/Manufacture/img3 (3).png";

// --- FIX: MOVE DATA OUTSIDE THE COMPONENT ---
// Since this data doesn't rely on props or state, defining it here
// prevents it from being re-created on every render.
const data = {
  press: [
    { id: 1, title: "High-Tonnage Stamping", desc: "Robust press machines for forming automotive components.", img: img1 },
    { id: 2, title: "Tooling & Die Integration", desc: "Integrated tooling ensuring dimensional accuracy.", img: img2 },
    { id: 3, title: "Precision Material Feeding", desc: "Automated coil feeding systems for high speed.", img: img3 }
  ],
  cnc: [
    { id: 4, title: "Multi-Axis CNC Operations", desc: "Modern CNC machines supporting turning and milling.", img: img4 },
    { id: 5, title: "Advanced CNC Facility", desc: "High-precision machines for tight tolerances.", img: img5 },
    { id: 6, title: "Precision Component Machining", desc: "Focused machining of high-precision parts.", img: img6 }
  ],
  assembly: [
    { id: 7, title: "Component Assembly", desc: "Systematic assembly processes for correct fitment.", img: img7 },
    { id: 8, title: "Inspection & Testing", desc: "In-line inspection to verify quality compliance.", img: img8 },
    { id: 9, title: "Robotic Welding Cells", desc: "Automated welding ensuring consistent strength.", img: img9 }
  ]
};

const Facilities = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeTab, setActiveTab] = useState('cnc'); 
  const [expandedId, setExpandedId] = useState(null);

  // Effect: When tab changes, default the Center Image (index 1) to be expanded
  // Now 'data' is defined outside, so it is not needed in the dependency array.
  useEffect(() => {
    const currentItems = data[activeTab];
    if (currentItems && currentItems.length > 1) {
      setExpandedId(currentItems[1].id);
    }
  }, [activeTab]);

  return (
    <section className="facilities-section" id="infrastructure">
      <Container>
        {/* Header */}
        <div data-aos="fade-down" className="text-center text-lg-start">
          <span className="facility-subheading">Manufacturing Facilities</span>
          <h2 className="facility-heading">Our Manufacturing Infrastructure</h2>
        </div>

        {/* Tabs */}
        <div className="facility-tabs" data-aos="fade-up">
          {['press', 'cnc', 'assembly'].map((tab) => (
            <button 
              key={tab}
              className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === 'press' ? 'Press Shop' : tab === 'cnc' ? 'CNC Machining' : 'Assembly Line'}
            </button>
          ))}
        </div>

        {/* Dynamic Grid */}
        <div className="facility-grid">
          {data[activeTab].map((item, index) => (
            <div 
              key={item.id} 
              // Wrapper tracks flex expansion
              className={`facility-card-wrapper ${expandedId === item.id ? 'expanded' : ''}`}
              onMouseEnter={() => setExpandedId(item.id)}
              /* data-aos="fade-up"
              data-aos-delay={index * 100} */
            >
              {/* Image Container */}
              <div className="facility-img-container">
                <img src={item.img} alt={item.title} className="facility-bg-img" />
              </div>
              
              {/* Orange Info Box */}
              <div className="facility-info-box">
                <div className="info-arrow"><BsArrowRight /></div>
                <h3 className="info-title">{item.title}</h3>
                <p className="info-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </Container>
    </section>
  );
};

export default Facilities;